import React from "react";
import { TimerIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
const DURATION_SECONDS = 17 * 60 + 34; // 00:17:34

function pad(n: number) {
  return n.toString().padStart(2, "0");
}
export function Countdown() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(DURATION_SECONDS);
  const units = [{
    label: "Hours",
    value: hours
  }, {
    label: "Minutes",
    value: minutes
  }, {
    label: "Seconds",
    value: seconds
  }];
  return <div className="mx-auto mt-6 w-full max-w-xl rounded-2xl border-2 border-before bg-before/10 p-4" role="timer" aria-live="off" data-id="element-115" data-mp="3h0z6t7yba12v">
      <p className="flex items-center justify-center gap-2 text-center text-[14px] font-bold uppercase tracking-wide text-white" data-id="element-116" data-mp="324rn08qtf1o4">
        <TimerIcon className="h-5 w-5 text-before" aria-hidden="true" data-id="element-117" data-mp="3731jqns6uabu" />
        This promotional price ends in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-1.5" data-id="element-118" data-mp="10aimw34dwj7b">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-119" data-mp="15925punolevg" data-mpi={i}>
            {i > 0 && <span className="pt-1.5 font-display text-3xl font-extrabold text-before" data-id="element-120" data-mp="xzvipeo9v61p">:</span>}
            <div className="flex min-w-0 max-w-[88px] flex-1 flex-col items-center" data-id="element-121" data-mp="t125zogt7j2l">
              <span className="w-full rounded-xl bg-before py-2 text-center font-display text-[40px] font-extrabold leading-none tabular-nums text-white" data-id="element-122" data-mp="17r9dj95a3hoi">
                {pad(u.value)}
              </span>
              <span className="mt-1.5 text-[11px] font-semibold uppercase tracking-wider text-mist" data-id="element-123" data-mp="f3dis9z9rzud">{u.label}</span>
            </div>
          </React.Fragment>)}
      </div>
    </div>;
}